import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdatePhoneNumberComponent } from './update-phone-number.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';



@NgModule({
  declarations: [
    UpdatePhoneNumberComponent,
    
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ]
})
export class UpdatePhoneNumberModule { }
